import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import { dsClass } from '../../common/constants/dsClasses';
import { instructionsForSimCardMsg, instructionsMsg, simCardMsg, t } from '../../common/i18n';
import {
  hasEsimQrCode,
  isExternalSubscription,
  isSubscriptionInSaunalahti,
  isSubscriptionInSfdc,
  simCardChangeAllowed,
} from '../../common/utils/subscriptionUtils';
import { getCategoryBySubscriptionType } from '../../public/common/util/category';
import { DetailsWithCard } from '../DetailsWithInfoColumn/DetailsWithInfoColumn';
import { SimCard } from '../SimCard/SimCard';
import { SaunalahtiCardContent } from './Components/CardContent';
import { SubscriptionDetailsLinkBlocks, SubscriptionDetailsLinkType } from './SubscriptionDetailsLinkBlocks';
import type { CompanyInfoResponse } from '../../generated/api/companyInfoResponse';
import type { Subscription } from '../../generated/api/subscription';

export interface MobileSubscriptionSimCardProps {
  subscription: Subscription;
  hasPendingActions: boolean;
  companyInfo?: CompanyInfoResponse;
}

export const MobileSubscriptionSimCard = ({
  subscription,
  hasPendingActions,
  companyInfo,
}: MobileSubscriptionSimCardProps) => {
  const esimQrCode = hasEsimQrCode(subscription);
  const simCardChangeEnabled =
    simCardChangeAllowed(subscription) && isSubscriptionInSfdc(subscription) && !hasPendingActions;
  const linkTypes = [];
  if (!hasPendingActions) {
    if (simCardChangeEnabled || esimQrCode) {
      linkTypes.push(SubscriptionDetailsLinkType.ACTIVATE_SIM);
    }
    if (simCardChangeEnabled) {
      linkTypes.push(SubscriptionDetailsLinkType.ORDER_SIM);
    }
  }
  return (
    <DetailsWithCard
      cardContent={
        isSubscriptionInSaunalahti(subscription) ? (
          <SaunalahtiCardContent />
        ) : (
          <>
            <h3>{t.RD4R(instructionsMsg)}</h3>
            <p>{t.XVAH(instructionsForSimCardMsg)}</p>
          </>
        )
      }
    >
      <h3 className={classNames(dsClass.H3_BOOK, dsClass.MARGIN_BOTTOM_6)}>{t.PIZC(simCardMsg)}</h3>
      <CL.Grid>
        <CL.GridRow>
          <CL.GridCol className={dsClass.PADDING_LEFT_0} colsS={6} colsM={6} colsL={6}>
            <SimCard
              hasPendingActions={hasPendingActions}
              simCardConfig={{
                simCardNumber: subscription.details!.mobile!.simCardNumber,
                simType: subscription.details!.mobile!.simType,
              }}
              sourceIsExternal={isExternalSubscription(subscription)}
              simCardChangeAllowed={simCardChangeAllowed(subscription)}
              hasEsimQrCode={hasEsimQrCode(subscription)}
              actions={false}
              singleColumn={true}
            />
          </CL.GridCol>
          <CL.GridCol className={dsClass.PADDING_RIGHT_0} colsS={6} colsM={6} colsL={6}>
            <SubscriptionDetailsLinkBlocks
              linkTypes={linkTypes}
              companyInfo={companyInfo}
              subscription={subscription}
              hasPendingActions={hasPendingActions}
              category={getCategoryBySubscriptionType(subscription.subscriptionType)}
            />
          </CL.GridCol>
        </CL.GridRow>
      </CL.Grid>
    </DetailsWithCard>
  );
};
